import { render, staticRenderFns } from "./balance-manage.vue?vue&type=template&id=83c57348&"
import script from "./balance-manage.vue?vue&type=script&lang=js&"
export * from "./balance-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports